// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"7b56f09b","787":"f1026ea1"}[chunkId] + ".chunk.js";
};